import { MessageSquare, History, Bookmark, Sparkles, type LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useState } from 'react';
import { IAPanel } from './IAPanel';

/**
 * IA-Rail direito — handoff COMPONENTS §9
 * 60px width: ia-orb 42x42 tri-tone (lilac/clay/mint) com Sparkles centralizado + pulse ring
 * + 3 rail-btn (chat, histórico, salvos)
 */

interface IARailItem {
  key: string;
  label: string;
  icon: LucideIcon;
  onClick?: () => void;
}

export function RailRight() {
  const [open, setOpen] = useState(false);

  const items: IARailItem[] = [
    { key: 'chat', label: 'Conversar com a IA', icon: MessageSquare, onClick: () => setOpen(true) },
    { key: 'history', label: 'Histórico', icon: History },
    { key: 'bookmark', label: 'Salvos', icon: Bookmark },
  ];

  return (
    <>
      <aside className="hidden lg:flex w-[60px] flex-col items-center gap-2 border-l border-frame-edge bg-frame px-2 py-4 sticky top-16 h-[calc(100dvh-4rem)] z-30">
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? 'Fechar IA' : 'Abrir IA'}
          aria-pressed={open}
          className={cn(
            'group relative grid h-[42px] w-[42px] place-items-center rounded-full',
            'bg-[radial-gradient(120%_100%_at_0%_0%,rgba(255,255,255,0.55),transparent_60%),conic-gradient(from_220deg_at_50%_50%,#D5C8E8_0deg,#EDCBB4_140deg,#BFDDC9_260deg,#D5C8E8_360deg)]',
            'shadow-[inset_0_1px_0_rgba(255,255,255,0.40),inset_0_-2px_4px_rgba(40,30,80,0.18),0_4px_12px_-4px_rgba(120,100,180,0.40)]',
            'transition-all duration-fast hover:-translate-y-px active:translate-y-0',
            'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lilac-deep focus-visible:ring-offset-2 focus-visible:ring-offset-frame',
          )}
        >
          <Sparkles
            className="h-[18px] w-[18px] text-[#2A2240] drop-shadow-[0_1px_0_rgba(255,255,255,0.4)]"
            strokeWidth={2.2}
          />
          <span className="pointer-events-none absolute inset-0 rounded-full ring-2 ring-lilac-deep/30 animate-pulse-ring" />
          <span className="pointer-events-none absolute right-full mr-3 whitespace-nowrap rounded-[10px] bg-ink px-2 py-1 font-mono text-[11px] text-on-ink opacity-0 shadow-clay-ink group-hover:opacity-100 transition-opacity z-[60]">
            {open ? 'Fechar IA' : 'Abrir IA'}
          </span>
        </button>

        <span className="h-px w-7 bg-card-stroke my-1" />

        {items.map((item) => {
          const Icon = item.icon;
          return (
            <button
              key={item.key}
              type="button"
              onClick={item.onClick}
              aria-label={item.label}
              className={cn(
                'group relative grid h-11 w-11 place-items-center rounded-[14px] transition-all duration-fast',
                'text-fg-muted hover:text-fg hover:bg-card-soft',
              )}
            >
              <Icon className="h-[18px] w-[18px]" strokeWidth={1.8} />
              <span className="pointer-events-none absolute right-full mr-3 whitespace-nowrap rounded-[10px] bg-ink px-2 py-1 font-mono text-[11px] text-on-ink opacity-0 shadow-clay-ink group-hover:opacity-100 transition-opacity z-[60]">
                {item.label}
              </span>
            </button>
          );
        })}
      </aside>

      <IAPanel open={open} onClose={() => setOpen(false)} />
    </>
  );
}
